const Tick02Icon = /*#__PURE__*/ [
  ["path", { d: "M5 14L8.5 17.5L19 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { Tick02Icon as default };
//# sourceMappingURL=Tick02Icon.js.map
